export const Sizes = {
    bigFontSize: '4.3rem',
    bigFontSize2: '3.3rem',
    bigFontSize3: '3rem',
    bigFontSize4: '2rem',

    mediaQueryBreak1: '1024px',
    mediaQueryBreak2: '770px',
    mediaQueryBreak3: '480px',
    mediaQueryBreak4: '300px',
}